// @flow
import * as React from 'react';
import gql from 'graphql-tag';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';

import { selectStudentIdListRecipient, clearSelection } from 'reducers/roleBasedMessagingSearch';

import type { StudentIdListRecipient } from 'reducers/roleBasedMessagingSearch';

type Props = {
  children: Function,
  schoolUuids: string[],

  // redux dispatchers
  selectStudentIdListRecipient: (recipient: StudentIdListRecipient) => void,
  clearSelection: () => *,

  // graphql data
  data: ReactApolloData<TargetByStudentIdContainerQuery>,
};

class TargetByStudentIdContainer extends React.Component<Props, void> {
  isLoading = (props: Props): boolean => {
    return props.data.loading || props.data.networkStatus < 7;
  };

  getOrgs = (props: Props): *[] => {
    return props.data.organizations || null;
  };

  render() {
    return this.props.children({
      loading: this.isLoading(this.props),
      schools: this.getOrgs(this.props),
      selectStudentIdListRecipient: this.props.selectStudentIdListRecipient,
      clearSelection: this.props.clearSelection,
    });
  }
}

const mapDispatchToProps = (dispatch: Function) =>
  bindActionCreators(
    {
      selectStudentIdListRecipient,
      clearSelection,
    },
    dispatch
  );

const withOrgs = graphql(
  gql`
    query TargetByStudentIdContainer($uuids: [String!]) {
      organizations(uuids: $uuids) {
        uuid
        name
        studentIdPercentage
        permissions {
          canSendToStudentIdList
        }
      }
    }
  `,
  {
    options: ({ schoolUuids }) => ({
      variables: {
        uuids: schoolUuids,
      },
    }),
  }
);

export { TargetByStudentIdContainer };

export default compose(connect(undefined, mapDispatchToProps), withOrgs)(
  TargetByStudentIdContainer
);
